import { render, staticRenderFns } from "./JcdcModalCard.vue?vue&type=template&id=631423ab"
import script from "./JcdcModalCard.vue?vue&type=script&lang=ts"
export * from "./JcdcModalCard.vue?vue&type=script&lang=ts"
import style0 from "./JcdcModalCard.vue?vue&type=style&index=0&id=631423ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports